import Title from "antd/lib/typography/Title";
import { memo } from "react";

const PageHeader = ({ title, extra }) => {
  return (
    <div className="mb-5 flex justify-between items-start flex-wrap gap-2">
      <Title className="mb-0 leading-8 lg:flex-1" level={2}>
        {title}
      </Title>
      <div className="flex items-center flex-wrap gap-1.5">{extra}</div>
    </div>
  );
};
export default memo(PageHeader);
